import { Observable } from "rxjs/Observable";

// Classes.
import { ViewData } from "./view-data";
import { ResponseData } from "../fetching/wa-response/wa-api-response";

// Providers.
import { LoggerService } from "../logger/logger-service";
import { DataFetchService } from "../wa-services/data-fetch-service";
import { DatabaseService } from "../wa-services/database-service";
import { FactoryService } from "../wa-services/factory-service";
import { WaHelperService } from "../wa-services/wa-helper-service";

// Interfaces.
import { LocatorInterface } from "../interfaces/locator.interface";
import { ViewDataConfigStruct } from "../interfaces/view-data.interface";
import { SeriesStagesItem } from "../fetching/types/series-stages.info.item";
import { SeriesItem } from "../fetching/types/series.item";
import { SeriesProItem } from "../fetching/types/series-pro.item";

export class SeriesProView extends ViewData<SeriesProItem> {
  constructor(
    protected logger: LoggerService,
    protected fetchSrvc: DataFetchService,
    protected db: DatabaseService,
    protected factory: FactoryService,
    protected _helper: WaHelperService,
    protected _locator: LocatorInterface
  ) {
    super(logger, db, _locator);
  }

  public configureView() {
    const viewDataConf = new ViewDataConfigStruct();
    viewDataConf.maxAge = 1800;
    viewDataConf.expectedItems = 10;
    this.applyConfiguration(viewDataConf);
  }

  public updateData(): Observable<ResponseData> {
    return this.fetchSrvc.requestSeriesProList(this.locator, this.pageInfo());
  }

  public mapItem(rawItem: any): SeriesProItem {
    return this.factory.newSeresProItems(rawItem);
  }
}
